<template>
  <div class="filter-bar__sort">
    <label :for="selectId">Ordenar</label>
    <select :id="selectId" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
      <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
    </select>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'SortSelect',
  props: {
    // [{ value, label, field, type?, dir? }]
    options: { type: Array, required: true },
    modelValue: { type: [String, Number], default: '' }
  },
  emits: ['update:modelValue'],
  data () {
    return { selectId: 'sort-' + (++uid) }
  }
}
</script>
